// ETF 공통 유틸 — 목록/상세/비교 화면이 동일한 포맷·계산 로직을 공유한다.

// 구분(type)을 유연하게 인식: 미국형/usa/us/미국 → 'usa', 그 외 → 'korea'
export function normalizeType(t) {
  const s = String(t || '').toLowerCase();
  if (s.includes('usa') || s === 'us' || s.includes('미국') || s.includes('us_etf')) return 'usa';
  return 'korea';
}

export const hasVal = (v) => v !== undefined && v !== null && v !== '';
export const fmtWon = (n) => hasVal(n) ? Number(n).toLocaleString('ko-KR') + '원' : '—';
export const fmtAum = (n) => hasVal(n) ? Number(n).toLocaleString('ko-KR') + '억' : '—';
export const fmtPct = (n) => hasVal(n) ? `${Number(n) > 0 ? '+' : ''}${Number(n)}%` : '—';
export const pctColor = (n) =>
  !hasVal(n) ? '#9ca3af' : Number(n) > 0 ? '#4ade80' : Number(n) < 0 ? '#f87171' : '#9ca3af';

// 현재가와 기준가(NAV)로 괴리율(%) 계산: (현재가 - 기준가) / 기준가 × 100
export function disparity(price, nav) {
  if (!hasVal(price) || !hasVal(nav) || Number(nav) === 0) return undefined;
  return ((Number(price) - Number(nav)) / Number(nav)) * 100;
}

// 수익률 기간 정의 (키, 라벨, 개월 수)
export const RETURN_PERIODS = [
  ['1m', '1개월', 1],
  ['3m', '3개월', 3],
  ['6m', '6개월', 6],
  ['1y', '1년', 12],
];

// 시계열 차트용 버킷: 과거 → 현재 순
export const TREND_BUCKETS = ['1년 전', '6개월 전', '3개월 전', '1개월 전', '현재'];

/**
 * 기간 수익률로 가격 추이를 역산한다.
 *   과거가 = 현재가 / (1 + 수익률/100)
 * 가격이 없으면 현재=100 으로 지수화한 추정치를 만든다.
 * 반환: TREND_BUCKETS 와 1:1 정렬된 배열(데이터 없는 구간은 null).
 */
export function getTrendValues(etf) {
  const r = (etf && etf.returns) || {};
  const base = hasVal(etf && etf.price) ? Number(etf.price) : 100;
  const back = (key) => (hasVal(r[key]) ? base / (1 + Number(r[key]) / 100) : null);
  return [back('1y'), back('6m'), back('3m'), back('1m'), base];
}

// 추이 데이터가 1개 이하면 선을 그릴 수 없다.
export function hasTrend(etf) {
  return getTrendValues(etf).filter((v) => v !== null).length >= 2;
}

// 비교 차트 오버레이용 색상 팔레트
export const COMPARE_COLORS = ['#60a5fa', '#a78bfa', '#34d399', '#fbbf24', '#f472b6', '#22d3ee'];

export const glassCard = {
  background: 'rgba(255,255,255,0.06)',
  backdropFilter: 'blur(20px)',
  WebkitBackdropFilter: 'blur(20px)',
  border: '1px solid rgba(255,255,255,0.12)',
};
